import { Button, Modal, Box, Typography } from '@mui/material';
import { deepPurple } from '@mui/material/colors';
import { Delete } from '@mui/icons-material';
import { useState } from 'react';
import { successAlert, errorAlert } from 'ui-component/Toasts';
import { useSelector } from 'react-redux';
import { axiosInstance } from 'utils/axios';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: 'fix-content',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const DeleteCustomerTasklistRecord = ({ customerTasklistRecordID }) => {
    const token = useSelector(selectCurrentToken);
    const [open, setOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const deleteCustomerTasklistRecord = async (id) => {
        // COMMENTED OUT as the api is not ready.
        setDeleting(true);
        axiosInstance
            .delete(`/CustomerTasklist/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((response) => {
                // Handle successful response
                setOpen(false);
                successAlert('Record deleted successfully');
                window.location.reload(); // Reload the page to see the updated data
            })
            .catch((error) => {
                setOpen(false);
                errorAlert('Error deleting record');
            })
            .finally(() => {
                setDeleting(false);
            });
        console.log('Deleting customer tasklist record...', id);
    };

    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500]
                }}
            >
                <Delete />
            </Button>

            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h3" component="h2" sx={{ textAlign: 'center', mb: 5 }}>
                        Are you sure you want to delete this record?
                    </Typography>

                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: '10px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => deleteCustomerTasklistRecord(customerTasklistRecordID)}
                            disabled={deleting}
                        >
                            Yes
                        </Button>
                        <Button variant="contained" color="secondary" onClick={() => setOpen(false)}>
                            Cancel
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default DeleteCustomerTasklistRecord;
